import Action from '@core/models/user/pushNotifications/Action';

import { ActionDto } from './dtos/ActionDto';

export function transformAction(dto: ActionDto): Action {
    return {
        id: dto.Id,
        name: dto.Name.toLowerCase(),
    };
}
